import React from 'react';
import "../../styles/Css/TermsOfService.css"

const TermsOfService = () => {
    const lastUpdated = "Feb 26, 2026";

    const navItems = [
        { id: "how-it-works", label: "1. How It Works" },
        { id: "registration", label: "2. Account Responsibilities" },
        { id: "ownership", label: "3. User Content & Ownership" },
        { id: "integrations", label: "4. Third-Party Services" },
        { id: "acceptable-use", label: "5. Acceptable Use" },
        { id: "billing", label: "6. Subscriptions & Billing" },
        { id: "intellectual-property", label: "7. Intellectual Property" },
        { id: "disclaimers", label: "8. Disclaimers" },
        { id: "liability", label: "9. Limitation of Liability" },
        { id: "termination", label: "10. Termination" },
        { id: "governing-law", label: "11. Governing Law" },
        { id: "changes", label: "12. Changes to Terms" },
        { id: "contact", label: "13. Contact Information" },
    ];

    return (
        <div className="legal-page">
            <section className="legal-hero">
                <div className="container">
                    <span className="legal-badge">Service Agreement</span>
                    <h1 className="legal-hero__title">Terms & Conditions</h1>
                    <p className="legal-subtitle">Deal To Close (AI) Pvt Ltd – Terms of Service</p>
                    <p className="legal-hero__date">Last updated: <strong>{lastUpdated}</strong></p>
                    <div className="policy-intro" style={{ maxWidth: "700px", margin: "20px auto 0" }}>
                        <p>These Terms & Conditions govern your access to and use of Deal To Close (AI) Pvt Ltd. By using the Services, you agree to these Terms.</p>
                    </div>
                </div>
            </section>

            <section className="legal-content section">
                <div className="container legal-grid">

                    {/* Sticky Sidebar */}
                    <aside className="legal-sidebar">
                        <div className="sidebar-sticky">
                            <p className="sidebar-title">Terms Navigation</p>
                            <nav>
                                <ul>
                                    {navItems.map(item => (
                                        <li key={item.id}>
                                            <a href={`#${item.id}`}>{item.label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>
                    </aside>

                    <div className="legal-document">
                        <h2 id="how-it-works">How Deal To Close (AI) Pvt Ltd Works</h2>
                        <p>
                            Deal To Close (AI) Pvt Ltd is a software-as-a-service platform designed to help real estate professionals manage contracts, transactions, communications, and workflows in one centralized system. Each transaction is organized into a structured workspace where documents, emails, contacts, tasks, and deadlines are tied together for clarity and accountability.
                        </p>
                        <p>
                            The platform uses automation and artificial intelligence to assist users by extracting key information from contracts, calculating important dates, creating task lists, and organizing communication. AI features are designed to support efficiency, not replace professional judgment. Users retain full control over approvals, edits, and decisions.
                        </p>

                        <h2 id="registration">Account Registration and Responsibilities</h2>
                        <p>
                            Users must provide accurate information when creating an account and are responsible for maintaining the confidentiality of login credentials. You are responsible for all activities conducted through your account and for ensuring that authorized users comply with these Terms.
                        </p>

                        <h2 id="ownership">User Content and Ownership</h2>
                        <p>
                            You retain ownership of all documents and data you upload to Deal To Close (AI) Pvt Ltd. By using the Services, you grant Deal To Close (AI) Pvt Ltd a limited license to host, process, and display your content solely to provide the platform’s functionality.
                        </p>
                        <p>You are responsible for ensuring you have the legal right to upload and share any content. </p>

                        <h2 id="integrations">Integrations and Third-Party Services</h2>
                        <p>
                            Deal To Close (AI) Pvt Ltd integrates with third-party platforms such as Google, Microsoft, email providers, CRMs, and mapping services. These services operate under their own terms and policies. Deal To Close (AI) Pvt Ltd is not responsible for third-party service interruptions or changes.
                        </p>
                        <p>You may revoke integrations at any time.</p>

                        <h2 id="acceptable-use">Acceptable Use</h2>
                        <p>
                            You agree not to misuse the platform, violate laws, infringe intellectual property rights, upload harmful content, or attempt to interfere with the platform’s security or functionality.
                        </p>

                        <h2 id="billing">Subscriptions and Billing</h2>
                        <p>
                            Access to certain features may require a paid subscription. Fees, billing cycles, and renewal terms are presented at the time of purchase. Payments are non-refundable unless required by law.
                        </p>

                        <h2 id="intellectual-property">Intellectual Property</h2>
                        <p>
                            All platform software, designs, branding, and proprietary technology are owned by Deal To Close (AI) Pvt Ltd. Users receive a limited, non-exclusive, non-transferable license to use the Services.
                        </p>

                        <h2 id="disclaimers">Disclaimers</h2>
                        <div className="highlight-box" style={{ background: "#fff5f5", borderLeftColor: "#f56565" }}>
                            <p>
                                Deal To Close (AI) Pvt Ltd is provided “as is” and “as available.” We do not guarantee uninterrupted service or error-free operation. AI-generated outputs are assistive and should not be considered legal or professional advice.
                            </p>
                        </div>

                        <h2 id="liability">Limitation of Liability</h2>
                        <p>
                            To the maximum extent permitted by law, Deal To Close (AI) Pvt Ltd is not liable for indirect, incidental, or consequential damages.
                        </p>

                        <h2 id="termination">Termination</h2>
                        <p>
                            We may suspend or terminate access for violations of these Terms, security concerns, or legal requirements. Users may cancel their account at any time.
                        </p>

                        <h2 id="governing-law">Governing Law</h2>
                        <p>These Terms are governed by applicable laws without regard to conflict-of-law principles.</p>

                        <h2 id="changes">Changes to Terms</h2>
                        <p>We may update these Terms periodically. Continued use of the Services constitutes acceptance of updated Terms.</p>

                        <hr className="section-divider" />

                        <h2 id="contact">Contact Information</h2>
                        <div className="contact-card">
                            <p>For questions about these Terms, please contact us at:</p>
                            <div className="contact-details" style={{ marginTop: "15px" }}>
                                <strong>Deal to Close AI</strong><br />
                                <span>Email: </span><a href="mailto:legal@dealtoclose.ai">legal@dealtoclose.ai</a><br />
                                <span>Address: </span> 123 Tech Drive, San Francisco, CA 94105
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TermsOfService;